import { SystemAccessProfileCode } from './permissions';

export type AccessProfileCopy = {
  description: string;
  highlights: string[];
  limitations: string[];
};

/** Plain-language copy for system access profiles (PT). */
export const ACCESS_PROFILE_COPY: Record<SystemAccessProfileCode, AccessProfileCopy> = {
  admin: {
    description:
      'Controle total da organização: operação, equipe, unidades, assinatura e recebimentos via Stripe Connect.',
    highlights: [
      'Dashboard, analytics e todos os módulos operacionais',
      'Gerenciar usuários, perfis de acesso e unidades',
      'Billing, Connect e configurações sensíveis',
    ],
    limitations: [],
  },
  manager: {
    description:
      'Operação completa do dia a dia — pedidos, comandas, cardápio, estoque e equipe — sem billing org ou Connect.',
    highlights: [
      'Gerenciar pedidos, comandas, cardápio e estoque',
      'Convidar e editar equipe (exceto rebaixar admin)',
      'Ver analytics e faturas',
    ],
    limitations: ['Sem assinatura/billing da org', 'Sem Stripe Connect org-wide'],
  },
  bar: {
    description:
      'Estação de bar/balcão: prepara e entrega pedidos, opera comandas e cobra pagamentos no local.',
    highlights: [
      'KDS de bebidas — preparar e marcar entrega',
      'Abrir comandas, itens, mesas e fechar com cobrança',
      'Ver cardápio',
    ],
    limitations: ['Sem reembolso', 'Sem editar cardápio ou usuários'],
  },
  kitchen: {
    description:
      'Cozinha (KDS): acompanha pedidos e avança o preparo até “pronto”. Não entrega nem cobra.',
    highlights: [
      'Ver fila de pedidos da unidade',
      'Avançar status de preparo (enviado → preparando → pronto)',
      'Consultar cardápio',
    ],
    limitations: [
      'Não marca entrega na mesa',
      'Sem comandas, pagamentos ou captura',
    ],
  },
  waiter: {
    description:
      'Salão: atende mesas, abre comandas, registra pedidos, entrega e cobra. Foco na pista.',
    highlights: [
      'Comandas, mesas e novos pedidos',
      'Entregar pedidos prontos (3 → 4)',
      'Cobrar e fechar comanda',
    ],
    limitations: [
      'Sem reembolso',
      'Sem editar cardápio, estoque ou usuários',
    ],
  },
  investor: {
    description:
      'Sócio/investidor: acompanha indicadores e operação em modo leitura. Não opera o ponto.',
    highlights: [
      'Dashboard e analytics',
      'Visão de pedidos, comandas, pagamentos e unidades',
    ],
    limitations: [
      'Somente leitura — sem preparar, entregar, cobrar ou editar',
      'Sem equipe, cardápio ou billing',
    ],
  },
  finance: {
    description:
      'Back-office financeiro: relatórios, faturas, reembolsos e leitura de estoque/unidades.',
    highlights: [
      'Analytics, faturas e status de pagamentos',
      'Solicitar reembolsos (Stripe)',
      'Ver billing da organização',
    ],
    limitations: [
      'Não atende salão nem edita cardápio',
      'Sem captura de pagamento no caixa',
    ],
  },
};

export const PERMISSION_MODULE_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  analytics: 'Analytics',
  orders: 'Pedidos',
  tabs: 'Comandas',
  payments: 'Pagamentos',
  menu: 'Cardápio',
  inventory: 'Estoque',
  invoices: 'Faturas',
  users: 'Equipe',
  venues: 'Unidades',
  billing: 'Assinatura',
  security: 'Segurança',
};
